// 三板确权 选择确权申报信息
// propData: { title: "", messageText: "" }
<template>
  <div class="select-stb-box">
    <div class="select-stb-title">{{ propData.title }}</div>
    <div class="select-stb-message">
      <el-radio-group v-model="select">
        <el-radio :label="stb.SCR_CD" v-for="stb in stbArr" :key="stb.SCR_CD">{{stb.SCR_CD}} - {{stb.SCR_NAME}}
        </el-radio>
      </el-radio-group>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    propData: {
      type: Object,
      default: {
        title: "请从以下内容中选择"
      }
    }
  },
  data () {
    return {
      select: "",
      stbArr: []
    };
  },
  created () {
    this.stbArr = this.propData.newStbArr;
  },
  watch: {
    select (newVal) {
      this.$emit("save", newVal);
    }
  }
};
</script>
<style lang="less" scoped>
@import "~@/styles/less/variable.less";
.select-stb-box {
  width: 100%;
  height: 100%;
  .select-stb-title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 130px 0 100px;
    font-size: 56px;
    font-weight: bold;
    line-height: 52px;
    color: #232323;
    &::before,
    &::after {
      content: "";
      display: block;
      width: 24px;
      height: 18px;
    }
    &::before {
      margin-right: 20px;
      background-image: url("~@img/home/05option/icon_zuo.png");
    }
    &::after {
      margin-left: 20px;
      background-image: url("~@img/home/05option/icon_you.png");
    }
  }
  .select-stb-message {
    margin: 0 auto;
    padding: 64px;
    width: 1000px;
    min-height: 350px;
    font-size: 30px;
    font-weight: 500;
    color: #4a4e53;
    line-height: 48px;
    background: #f5f7f8;
    border: 1px solid #dee1ea;
    box-sizing: border-box;
    /deep/ .el-radio-group {
      .el-radio {
        display: inline-flex;
        align-items: center;
        margin-left: 60px;
        margin-bottom: 20px;
        text-align: center;
        width: 300px;
        height: 66px;
        background: #fff;
        border: 2px solid #a5a9b3;
        border-radius: 4px;
        .el-radio__inner {
          display: none;
        }
        .el-radio__label {
          .module-item-text();
        }
        &.is-checked {
          background: rgba(0, 108, 210, 0.2);
          border-color: #006cd2;
          .el-radio__label {
            color: #006cd2;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/lib/ui/default/popup/src/content/selectStb.vue